import logo from '../logo.svg';
import '../App.css';

function FAQPage() {
  //localStorage.setItem('mode','none');
  return (

    <div className="App">
      <head>
        <title>Auxillia</title>
        {/* ION icons */}
        <link href = "https://unpkg.com/ionicons@4.5.10-0/dist/css/ionicons.min.css" rel = "stylesheet"></link>
        {/* <link rel="stylesheet" href = "App.css"></link> */}
      </head>
      
        <body className = "App-header">
          
          <section>
            <div class = "container">
            <h1>FAQ</h1>
              <div class = "accordion">
                <div class = "accordion-item" id = "question1">
                  <a class = "accordion-link" href = "#question1">
                    How does the payment system work?
                    <i class = "icon ion-md-add"></i>
                    <i class = "icon ion-md-remove"></i>
                  </a>
                  <div class = "answer">
                    <p>The payment system is designed to be user friendly. To engage with the chat you must pay before you ar allowed to connect with a tutor and ask a question. Auxillia will hold onto your payment until the chat session is complete. This means that you will not actually pay money until the chat session has ended and your question is satisfied. If you have any issues with your chat session and do not feel that the tutor answered your question satisfactorly you may request a refund.</p>
                  </div>
                </div>

                <div class = "accordion-item" id = "question2">
                  <a class = "accordion-link" href = "#question2">
                    I am a student, what if I want to become a tutor?
                    <i class = "icon ion-md-add"></i>
                    <i class = "icon ion-md-remove"></i>
                  </a>
                  <div class = "answer">
                    <p>In the top left corner there is a logout button. Logout of the student page and log in as a tutor. </p>
                  </div>
                </div>

                <div class = "accordion-item" id = "question3">
                  <a class = "accordion-link" href = "#question3">
                    I am a tutor, what if I want to become a student?
                    <i class = "icon ion-md-add"></i>
                    <i class = "icon ion-md-remove"></i>
                  </a>
                  <div class = "answer">
                    <p>In the top right corner there is a logout button. Logout of the tutor page and login as a student.</p>
                  </div>
                </div>

                <div class = "accordion-item" id = "question4">
                  <a class = "accordion-link" href = "#question4">
                    Scheduling times with a tutor?
                    <i class = "icon ion-md-add"></i>
                    <i class = "icon ion-md-remove"></i>
                  </a>
                  <div class = "answer">
                    <p>Go to the home page and enter the class you need help with. Choose the schedule option and choose a time from the drop down that works for you. A zoom link will be sent to your email and join at the time you chose.</p>
                  </div>
                </div>

                <div class = "accordion-item" id = "question5">
                  <a class = "accordion-link" href = "#question5">
                  Chat with a tutor?
                    <i class = "icon ion-md-add"></i>
                    <i class = "icon ion-md-remove"></i>
                  </a>
                  <div class = "answer">
                    <p>Go to the home page and enter the class you need help with. Choose the simple question option. Enter your question in the chat with the class code. Once you enter a question, a tutor will answer your question in the chat. </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          
          {/* <div class = "loginbox">
            <img src = "logo192.png" class = "logo"></img>
            <h1>Login</h1>
              <form>

                <input type = "submit" name = "" value = "Login as Student"></input>

                <input type = "submit" name = "" value = "Login as Tutor"></input>
              </form>
          </div> */}
        </body>
        {/* <footer>
          <p>Contact us at jeffauxillium@gmail.com</p>
          <p>Have a Question? Here is our  <a href = "/faq.js">FAQ</a></p>
        </footer> */}
        </div>
        


      //  <header className="App-header">
      //   <img src={logo} className="App-logo" alt="logo" />
      //   <p>
      //     Edit <code>src/App.js</code> and save to reload.
      //   </p>
      //   <p>
      //   Howdy!
      //   </p>
      //   <a
      //     className="App-link"
      //     href="https://reactjs.org"
      //     target="_blank"
      //     rel="noopener noreferrer"
      //   >
      //     Learn React
      //   </a>
      // </header>
      // <header className = "App-header">Howdy!</header>
      // <div id="grad1">wowza</div>
      
    
  );
}

export default FAQPage;
